// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.dpRl_{text-align:center;width:100%}.RuXvf{display:flex;justify-content:center;margin:30px 35px 45px}@media(max-width: 767px){.r9ln3{font-size:12px !important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "dpRl_",
	"contentWrapper": "RuXvf",
	"sliderMarkLabel": "r9ln3"
};
module.exports = ___CSS_LOADER_EXPORT___;
